import { Typographies } from '@/theme';
import { Typography, styled } from '@mui/material';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export const RootStyled = styled('div')<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ theme }) => ({
  position: 'relative',
  fontSize: Typographies.FONT_SIZE_INPUTS,
  cursor: 'pointer',
  height: 96,
  width: 96,
  borderRadius: '50%',
  background: theme.palette.dark.dark_6,
  border: `1px solid ${theme.palette.dark.dark_5}`,
  color: theme.palette.dark.dark_3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ImageIconWrapperStyled = styled('div')<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ theme }) => ({
  position: 'absolute',
  height: 32,
  width: 32,
  borderRadius: '50%',
  background: theme.palette.primary.main,

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  bottom: 0,
  right: 0,
}));
export const RequiredSignStyled = styled(Typography)(({ theme }) => ({
  position: 'absolute',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: 0,
  right: 0,
}));
